/**
 * Normalize MongoDB Decimal128 objects to numbers
 * @param value - Value that might be a Decimal128 object or a number
 * @returns Normalized number
 */
const normalizeDecimal = (value: any): number => {
  // Handle MongoDB Decimal128 objects
  if (value && typeof value === "object" && value.$numberDecimal) {
    return parseFloat(value.$numberDecimal);
  }

  // Handle regular numbers
  if (typeof value === "number") {
    return value;
  }

  // Handle string numbers
  if (typeof value === "string") {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }

  // Default fallback
  return 0;
};

export const formatNumberWithSeparator = (num: number | any): string => {
  const normalizedNum = normalizeDecimal(num);
  const [integerPart, fractionalPart] = normalizedNum.toString().split(".");
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return fractionalPart
    ? `${formattedInteger},${fractionalPart}`
    : formattedInteger;
};

/**
 * Format pre-converted price value from backend
 * @param convertedPrice - Already converted price value (might be Decimal128 object)
 * @returns Formatted price string with space separators
 */
export const formatConvertedPrice = (convertedPrice: number | any): string => {
  const normalizedPrice = normalizeDecimal(convertedPrice);
  const [integerPart, fractionalPart] = normalizedPrice.toString().split(".");
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return fractionalPart
    ? `${formattedInteger},${fractionalPart}`
    : formattedInteger;
};
